











import Vue              from 'vue'

import { Repository } from '@/db/_repo';
const db = new Repository();

export default Vue.extend({
    props: ['extraClasses'],
    data() {
        return {
            permissionError: false,
            thisUser: {},
            theseProfiles: []
        }
    },
    created() {
        if  (this.currentUser)  {
            this.$bind('theseProfiles', db.users.getProfileDataReactive(this.currentUser.uid)).then((docs) =>{
                if (docs) {
                    this.thisUser = docs[0];
                } else {
                    this.thisUser = this.currentUser;
                }
            })
        }
    }
})
